export enum TodoScreenNames {
  MAIN = 'todo-nav',
  TODO_LIST = 'todo-list',
}
